import * as React from "react";
import { Edit, FormDataConsumer, FormTab, ImageInput, TabbedForm, TextInput, Labeled, required } from 'react-admin';
import { GenericToolbar } from "../GenericStyle";
import { CustomRichTextInputToolbar, MyEditorOptions } from "../../Components/CustomRichText/CustomRichTextInput";
import { RichTextInput } from "ra-input-rich-text";
import CustomImageField from "../../Components/CustomImageField";
import { transform } from "./ResiliationCategoryUtil";

export const ResiliationCategoryEdit = (props) => {

    return (
        <Edit {...props} transform={transform}>
            <TabbedForm toolbar={<GenericToolbar />}>
                <FormTab label="Général">
                    <TextInput disabled label="Identifiant" source="id" />
                    <TextInput label="Nom" source="name" validate={required()} />
                    <TextInput label="URL" source="url" />
                    <TextInput label="Description" source="description" />
                </FormTab>
                <FormTab label="SEO">
                    {/* <FormDataConsumer>
                        {({ formData, dispatch, ...rest }) => {
                            return (
                                <div>
                                    <Button variant="contained" sx={{
                                        position: 'absolute',
                                        right: '40px'
                                    }} onClick={() => goToWebSite(formData, dataProvider)}>Voir sur le site</Button>
                                </div>
                            )
                        }}
                    </FormDataConsumer> */}
                    <TextInput source="titleText" label="Titre de l'article" />

                    <RichTextInput editorOptions={MyEditorOptions} toolbar={<CustomRichTextInputToolbar />} source="article" />

                    <TextInput source="metaTitle" label="Meta Title" />
                    <TextInput source="metaDescription" label="Meta Description" sx={{
                        '& .MuiFormControl-root': {
                            width: '700px'
                        }
                    }} />
                    <TextInput source="articleAltTextImage" label="Alt Image article" />
                    <ImageInput source="articleImage" label="Image article" multiple={false} accept="image/*" >
                        <CustomImageField source="src" title="title" />
                    </ImageInput>
                    <FormDataConsumer>
                        {({ formData, dispatch, ...rest }) => {
                            if (!formData.articleImage) {
                                return (
                                    <div>
                                        <Labeled label="Original article image">
                                            <CustomImageField record={formData} source="articleSrcImage" title="title" />
                                        </Labeled>
                                    </div>
                                );
                            }
                        }}
                    </FormDataConsumer>
                </FormTab>
            </TabbedForm>
        </Edit>
    )
}